import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting, readRevenueByHandlerByMonth, readRevenueByHandlerByYear,
    readRevenueByItem, readRevenueByTeamByMonth,
    readRevenueByTeamByQuarter, readRevenueByTeamByYear
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByHandlerByYear = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByHandlerByYear"],
        queryFn: async () => await readRevenueByHandlerByYear(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
